import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
// import { TransmissionRoutingModule } from "./transmission-routing.module";
import { SharedModule } from "../shared/shared.module";
import {
    TrRxPpdiRouteComponent,
    TrRxPayDetlsComponent,
    PrintAcptRejComponent,
    CommonModalComponent,
    TrRxActionsComponent,
    TrRxHeaderInfoComponent,
    TRRxOnlyComponent
} from ".";
import { provideNgxMask, NgxMaskPipe, NgxMaskDirective } from "ngx-mask";

@NgModule({
    imports: [CommonModule, SharedModule, NgxMaskPipe, NgxMaskDirective],
    declarations: [
        TRRxOnlyComponent,
        TrRxPpdiRouteComponent,
        TrRxPayDetlsComponent,
        PrintAcptRejComponent,
        CommonModalComponent,
        TrRxActionsComponent,
        TrRxHeaderInfoComponent
    ],
    exports: [TRRxOnlyComponent],
    providers: [provideNgxMask()]
})
export class TransmissionModule {}
